"use strict";

import Toolbox from "./toolbox";
import Mustache from "mustache";

export default function() {

	var componentHandler = {
		initComponents: function() {
			var components = document.querySelectorAll(".component-init");

			var activateComponent = function(component) {
				component.classList.remove("component-init");
				component.classList.add("component-active");
			};

			for (var i = 0; i < components.length; i++) {
				var component = components[i];

				switch (component.dataset.type) {
					case "select":
						this.selectComponent.init(component);
						activateComponent(component);
						break;
					case "accordions":
						this.accordions.init(component);
						activateComponent(component);
						var accs = component.querySelectorAll(".component[data-type=accordion]");
						for (var j = 0; j < accs.length; j++) {
							var acc = accs[j];
							if (acc.dataset.open === "true") {
								delete acc.dataset.open;
								componentHandler.accordions.clickHandler(acc);
							}

						}
						break;
					case "content-toggle":
						this.descriptionToggle.init(component);
						activateComponent(component);
						break;

					default:
						break;
				}
			}
		},
		descriptionToggle: {
			init: function(component) {
				var toggleButton = component.querySelector(".content-toggle-button");
				var toggleWrapper = component.querySelector(".toggle-content-wrapper");

				var minHeight = toggleWrapper.dataset.minHeight;
				if (minHeight) {
					toggleWrapper.style.height = minHeight;
				}

				toggleButton.addEventListener("click", this.clickHandler);
				toggleWrapper.addEventListener("transitionend", function(e) {
					var container = e.target;
					if (
						e.propertyName === "height" &&
						!container.classList.contains("show-less") &&
						container.classList.contains("toggle-content-wrapper")
					) {
						container.style.height = "auto";
					}
				});
			},
			clickHandler: function(e) {
				e.preventDefault();
				var toggleLink = e.target;
				var element = toggleLink.parentNode.querySelector(
					".toggle-content-wrapper"
				);

				if (element && element.classList.contains("show-less")) {
					element.style.height = element.scrollHeight + "px";
					element.classList.remove("show-less");
					toggleLink.textContent = toggleLink.dataset.openText || "Sulje";
				} else if (element) {
					var scrollheight = element.scrollHeight;
					element.style.height = scrollheight + "px";
					toggleLink.textContent = toggleLink.dataset.closedText || "Avaa";

					//Animate height hack.
					setTimeout(function() {
						element.classList.add("show-less");
						var minHeight = element.dataset.minHeight;
						if (minHeight) {
							element.style.height = minHeight;
						} else {
							element.style.height = "";
						}
					}, 0);
				}
			}
		},
		accordions: {
			init: function(accordion) {
				accordion.addEventListener("click", this.clickHandler);

				var viewWrappers = accordion.querySelectorAll(".view-wrapper");
				for (var i = 0; i < viewWrappers.length; i++) {
					viewWrappers[i].addEventListener("transitionend", function(e) {
						var wrapper = e.target;
						if (
							e.propertyName === "height" &&
							wrapper.classList.contains("view-wrapper")
						) {
							var active = Toolbox.closest(
								wrapper,
								".component-accordion.accordion-visible"
							);
							if (active) {
								wrapper.style.height = "auto";
							}
						}
					});
				}
			},
			clickHandler: function(e) {
				var selector = ".component[data-type=accordion]";
				var element = e;
				if (e.target) {
					element = e.target;
				}
				var clickedAccordion = Toolbox.closest(element, selector);

				var closeAccordion = function(accordion, clicked) {
					if (accordion !== clicked) {
						var accordionWrapper = accordion.querySelector(".view-wrapper");
						accordionWrapper.style.height =
							accordionWrapper.offsetHeight + "px";

						// Small hack (small dealy) in orded to get the css transition to work.
						// In theory it should work without this since height was calculated above.
						// But it doesn't... in practice. Too fast?
						setTimeout(function() {
							accordionWrapper.style.height = "";
							accordion.classList.remove("accordion-visible");
						}, 0);
					}
				};

				if (clickedAccordion) {
					var accordionGroup = Toolbox.closest(
						element,
						".accordion-group.component-active"
					);
					var accordions = accordionGroup.querySelectorAll(
						".component[data-type=accordion]"
					);

					if (accordionGroup.dataset.allowMultiopen !== "true") {
						for (var i = 0; i < accordions.length; i++) {
							var ele = accordions[i];
							if (!clickedAccordion.classList.contains("accordion-visible")) {
								closeAccordion(ele, clickedAccordion);
							}
						}
					}

					if (!clickedAccordion.classList.contains("accordion-visible")) {
						clickedAccordion.classList.add("accordion-visible");

						var viewWrap = clickedAccordion.querySelector(".view-wrapper");
						viewWrap.style.height = viewWrap.scrollHeight + "px";

						return true;
					} else if (clickedAccordion.classList.contains("accordion-visible")) {
						if (Toolbox.closest(element, ".view-wrapper")) {
							return false;
						}

						if (Toolbox.closest(element, selector)) {
							if (accordionGroup.dataset.allowCollapse !== "false") {
								closeAccordion(clickedAccordion);
							}
						}
						return true;
					}
				}
				return false;
			}
		},
		componentResetListener: function(component) {
			var form = Toolbox.closest(component, "form");
			if (form && form.dataset.componentResetListener !== "true") {
				form.addEventListener("reset", function() {
					setTimeout(function() {
						componentHandler.selectComponent.updateStates();
					}, 100);
				});
				form.dataset.componentResetListener = "true";
			}
		},
		selectComponent: {
			viewTemplate:
				'<div class="wrap"><ol>{{#.}}<li role="option" data-value="{{value}}">{{label}}</li>{{/.}}</ol></div>',
			updateOptionValue: function(select, value) {
				select.dataset.value = value;
				select.value = value;
				const event = new Event("change");
				select.dispatchEvent(event);
			},
			getSelectValues: function(component) {
				var options = component.querySelectorAll("select option");
				var values = [];
				var placeholder = [];
				for (var i = 0; i < options.length; i++) {
					var option = options[i];

					// "" values are considered as placeholder, thus not selectable.
					if (option.value) {
						values.push({
							value: option.value,
							label: option.textContent
						});
					} else {
						if (String(option.textContent).trim()) {
							placeholder.push(String(option.textContent).trim());
						}
					}
				}

				return { values: values, placeholder: placeholder };
			},
			init: function(component) {
				Mustache.parse(this.viewTemplate);
				var values = componentHandler.selectComponent.getSelectValues(
					component
				);
				component.dataset.values = JSON.stringify(values.values);
				componentHandler.selectComponent.observe(component);
				componentHandler.componentResetListener(component);

				var selected = component.querySelector(".component-selected");
				if (values.length) {
					selected.dataset.value = values[0].value;
				}
				componentHandler.selectComponent.updateState(component);

				if (values.placeholder.length) {
					selected.title = values.placeholder[0];
					selected.textContent = values.placeholder[0];
				}

				component.addEventListener("click", function(e) {
					var target = e.target;
					var clickedComponent = Toolbox.closest(
						target,
						".component-expand, .component-select-view"
					);
					if (clickedComponent) {
						if (clickedComponent.classList.contains("component-select-view")) {
							var selectedValue = target.dataset.value;
							if (selectedValue) {
								componentHandler.selectComponent.updateOptionValue(
									Toolbox.closest(target, ".component-select").querySelector(
										"select"
									),
									selectedValue
								);
								componentHandler.selectComponent.closeSelectView();
							}
						} else {
							var visibleSelectView = document.querySelectorAll(
								".select-view-visible"
							);

							var selectcomponent = Toolbox.closest(
								target,
								".component-select"
							);
							if (
								selectcomponent &&
								!selectcomponent.classList.contains("select-view-visible")
							) {
								var selectValues = JSON.parse(selectcomponent.dataset.values);

								var componentSelectView = selectcomponent.querySelector(
									".component-select-view"
								);
								if (componentSelectView) {
									if (selectValues && selectValues.length) {
										componentSelectView.innerHTML = Mustache.render(
											componentHandler.selectComponent.viewTemplate,
											selectValues
										);

										var currentlySelectedItem = componentSelectView.querySelector(
											'[data-value="' +
												selectcomponent.querySelector(".component-selected")
													.dataset.value +
												'"]'
										);
										if (currentlySelectedItem) {
											currentlySelectedItem.classList.add("selected");
											currentlySelectedItem.setAttribute(
												"aria-selected",
												"true"
											);
										}
									} else {
										componentSelectView.innerHTML = Mustache.render(
											'<div class="wrap"><p>Ei valintoja.</p></div>',
											selectValues
										);
									}
									addBlurListener(selectBlur);
									selectcomponent.classList.add("select-view-visible");
								}
							}

							for (var j = 0; j < visibleSelectView.length; j++) {
								visibleSelectView[j].classList.remove("select-view-visible");
							}

							if (
								visibleSelectView.length &&
								!selectcomponent.classList.contains("select-view-visible")
							) {
								removeBlurListener(selectBlur);
							}
						}
					}
				});
			},
			updateState: function(element) {
				if (element.target) {
					element = element.target;
				}

				var dataValues = element.dataset.values;
				if (dataValues && dataValues.length) {
					var dv = JSON.parse(dataValues);
					var values = {};

					for (var j = 0; j < dv.length; j++) {
						values[dv[j].value] = dv[j];
					}

					if (dv && dv.length) {
						var select = element.querySelector("select");

						if (
							select &&
							select.value !== undefined &&
							select.value !== null &&
							select.value !== ""
						) {
							var selectedLabel = element.querySelector(".component-selected");
							selectedLabel.textContent = values[select.value].label;
							selectedLabel.dataset.value = values[select.value].value;
							selectedLabel.title = values[select.value].label;
						}
					}
				}
			},
			closeSelectView: function() {
				var components = document.querySelectorAll(".select-view-visible");

				for (var i = 0; i < components.length; i++) {
					var element = components[i];
					element.classList.remove("select-view-visible");
				}
			},
			updateStates: function() {
				var selects = document.querySelectorAll(
					".component.component-select.component-active select"
				);
				for (var i = 0; i < selects.length; i++) {
					var select = selects[i];
					select.dataset.value = select.value;
				}
			},
			observe: function(element) {
				if (element) {
					var componentChangeObserver = new MutationObserver(function(e) {
						for (var i = 0; i < e.length; i++) {
							var mutator = e[i];
							var el = e[i].target;

							switch (mutator.attributeName) {
								case "data-value":
									if (
										el.tagName === "SELECT" &&
										mutator.oldValue !== el.value
									) {
										componentHandler.selectComponent.updateState(el.parentNode);
									}
									break;
							}
						}
					});

					componentChangeObserver.observe(element, {
						childList: false,
						attributes: true,
						subtree: true,
						attributeOldValue: true
					});
				}
			}
		}
	};

	function selectBlur(e) {
		var target = e.target;

		if (!Toolbox.closest(target, ".component.component-select")) {
			removeBlurListener(selectBlur);
			componentHandler.selectComponent.closeSelectView();
		}
	}

	function addBlurListener(callback) {
		document.body.addEventListener("click", callback);
	}

	function removeBlurListener(callback) {
		document.body.removeEventListener("click", callback);
	}

	try {
		componentHandler.initComponents();
	} catch (error) {
		console.log("Component init failed", error);
	}
}
